export const en = {
  comments: 'COMMENTS:',
  eventLog: 'EVENT LOG:',
  viewComments: 'View comments',
  viewLog: 'View log',
  showMore: 'Show more',
  filterAll: 'All',
  filterComments: 'Comments',
  filterActivity: 'Activity',
  showChanges: 'Show changes',
  hideChanges: 'Hide changes',
  suggestedByAi: 'Suggested by AI',
  loadingComments: 'Loading comments...',
  loadingActivity: 'Loading activity...'
};

export type Translations = typeof en;
